// MÔ TẢ
import { useSpring, animated } from '@react-spring/web'

import { createPortal } from 'react-dom'
export default function Modal({
  onClose,
  children,
  className,
  // openSatete,
}) {
  const fadeStyle = useSpring({
    opacity: 1,
    from: { opacity: 0 },
    config: { duration: 300 },
  })

  return createPortal(
    <animated.div
      style={fadeStyle}
      className="fixed inset-0 z-[50] flex items-center justify-center bg-black bg-opacity-30 p-3"
      onClick={onClose}
    >
      <div onClick={(e) => e.stopPropagation()} className={className}>
        {children}
      </div>
    </animated.div>,
    document.body
  )
}
